import Button from '../common/Button'
import Modal from '../common/Modal'

interface ModalCallReminderProps {
  isOpen: boolean
  closeModal: () => void
  confirmFinished: () => void
}

const ModalCallReminder = ({ isOpen, closeModal, confirmFinished }: ModalCallReminderProps) => {
  return (
    <Modal isOpen={isOpen} closeModal={() => closeModal()} showCloseButton={false}>
      <div className="mb-4 text-xs text-gray-500">Apakah anda yakin pelayanan sudah selesai?</div>
      <div className="grid grid-cols-2 gap-x-4">
        <Button onClick={() => confirmFinished()} type="button" variant="primary" block rounded="xl">
          Ya
        </Button>
        <Button onClick={() => closeModal()} type="button" variant="secondary" block rounded="xl">
          Tidak
        </Button>
      </div>
    </Modal>
  )
}

export default ModalCallReminder
